/** GET /api/v1/me — resolve the current principal from the bearer token. */
import { apiGet } from '../client.js';
import type { Me } from '../types.js';

export function getMe(): Promise<Me> {
  return apiGet<Me>('/api/v1/me');
}
